/**
 * To use this module, add the following data attribute to any element in your html:
 * data-js-module="variant-delivery-information"
 */
export default class VariantDeliveryInformation {
    constructor() {
        this.init();
    }

    init() {
        const element = document.getElementById('product-delivery-block');

        if (!element) {
            console.debug('[Delivery Information] Element #product-delivery-block does not exist');
            return;
        }

        const url = element.getAttribute('data-url');

        if (!url) {
            console.debug('[Delivery Information] Attribute data-url does not exist');
            return;
        }

        fetch(url)
            .then((response) => response.json())
            .then((data) => {
                if (!data) {
                    console.debug('[Delivery Information] Data is empty');
                    return;
                }

                if (!data.shipping_method_description || !data.delivery_estimation) {
                    console.debug('[Delivery Information] Invalid data');
                    return;
                }

                document.getElementById('product-delivery-name').innerHTML = data.shipping_method_description;
                document.getElementById('product-delivery-estimation').innerHTML = data.delivery_estimation;
            });
    }
}
